/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Plan_Duration_DaysInputs */

const en_plan_duration_days = /** @type {(inputs: Plan_Duration_DaysInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} day`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} days`);
	return /** @type {LocalizedString} */ ("plan_duration_days");
};

const es_plan_duration_days = /** @type {(inputs: Plan_Duration_DaysInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} día`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} días`);
	return /** @type {LocalizedString} */ ("plan_duration_days");
};

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} day" |
* | "other" | "{count} days" |
*
* @param {Plan_Duration_DaysInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_duration_days = /** @type {((inputs: Plan_Duration_DaysInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Duration_DaysInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_duration_days(inputs)
	return en_plan_duration_days(inputs)
});